import {showLoader, useUiStore} from "@/stores/ui-store.ts";
import {useEffect} from "react";

export function useGlobalLoader(isLoading = false, source = '') {
  const loader = useUiStore(state => state.loader);
  useEffect(() => {
    if (isLoading != loader) {
      showLoader(isLoading, source);
    }
  }, [isLoading]);

  const preventDialogClose = () => ({
    onPointerDownOutside: (e: any) => {
      if (document.body.classList.contains('loading')) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    onEscapeKeyDown: (e: any) => {
      if (document.body.classList.contains('loading')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  });
  return {
    showLoader,
    preventDialogClose,
  };
}